import { styled } from '@linaria/react'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const VideoPreviewsSC = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  border-radius: 8px;
`

export const VideoPreviewsBodySC = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding: var(${FIXED_INDENTS.INDENT_10});
  background: var(${COLOR.SURFACE_DARK_2});
  margin-top: var(${FIXED_INDENTS.INDENT_40});
  gap: var(${FIXED_INDENTS.INDENT_10});
  border-radius: 8px;

  ${MEDIA.MIN_600} {
    padding: var(${FIXED_INDENTS.INDENT_20});
    margin-top: var(${FIXED_INDENTS.INDENT_50});
  }

  ${MEDIA.MIN_1240} {
    margin-top: var(${FIXED_INDENTS.INDENT_60});
  }
`
